import React, { useState, useEffect } from 'react';

const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [media, setMedia] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showThumbnails, setShowThumbnails] = useState(true);

  // Función para detectar si un archivo es video
  const isVideoFile = (filename) => {
    const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.mkv', '.m4v'];
    return videoExtensions.some(ext => filename.toLowerCase().endsWith(ext));
  };

  // Función para detectar si un archivo es imagen
  const isImageFile = (filename) => {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.bmp'];
    return imageExtensions.some(ext => filename.toLowerCase().endsWith(ext));
  };

  useEffect(() => {
    // ============================================
    // AÑADE AQUÍ LOS NOMBRES DE TUS IMÁGENES Y VIDEOS
    // ============================================
    const mediaList = [
      'gallery/17_abstraccion_geometrica.jpg',
      'gallery/08_matrix_rain.jpg',
      'gallery/06_analisis_compositivo_yolo.jpg',
      'gallery/05_mascaras_individuales.jpg',
      'gallery/03_deteccion_mas_segmentacion.jpg',
      'gallery/02_solo_mascaras_segmentacion.jpg',
      'gallery/01_solo_cajas_deteccion.jpg',
      'gallery/29_combo_ilustracion_completa.jpg',
      'gallery/25_neon_cyberpunk.jpg',
      'gallery/24_boceto_lapiz.jpg',
      'gallery/22_comic_book.jpg',
      'gallery/21_ilustracion_digital_mejorada.jpg',
      'gallery/20_pop_art_warhol.jpg',
      'gallery/10_fuego_digital.jpg',
      'gallery/06_vectores_flujo.jpg',
      'gallery/28_combo_digital_illustration.jpg',
      'gallery/22_abstract_geometric.jpg',
      'gallery/21_neon_cyberpunk.jpg',
      'gallery/20_pencil_sketch.jpg',
      'gallery/19_comic_book.jpg',
      'gallery/06_vectores_flujo copia.jpg',
      'gallery/05_mascaras_individuales copia.jpg',
      'gallery/03_deteccion_mas_segmentacion copia.jpg',
      'gallery/02_solo_mascaras_segmentacion copia.jpg',
      'gallery/13_ondas_choque.jpg',
      'gallery/09_cristalizacion.jpg',
      'gallery/06_matrix_rain.jpg',
      'gallery/04_vectores_flujo.jpg',
      'gallery/02_mascaras_colores.jpg',
      'gallery/01_deteccion_cajas.jpg',
      'gallery/Velazquez-las_hilanderas_yolo12_vector.jpg',
      'gallery/Velazquez-las_hilanderas_yolo12_vector_mesh_plasma.jpg',
      'gallery/Velazquez-las_hilanderas_enhanced_vectors.jpg',
      'gallery/gem007.png',
      'gallery/gem006.png',
      'gallery/SHOWCASE_PRINCIPAL.jpg',
      'gallery/04e_sintesis_completa.jpg',
      'gallery/04c_estructura_geometrica.jpg',
      'gallery/03_neo_madrid_2087.jpg',
      'gallery/02_mito_aracne.jpg',
      'gallery/01_composicion_barroca.jpg',
      'gallery/analisis_vectorial.jpg',
      'gallery/gem005.png',
      'gallery/gem004.png',
      'gallery/gem003.png',
      'gallery/gem002.png',
      'gallery/gem001.png',
      'gallery/gaze1.png',
      'gallery/gaze2.png',
      'gallery/gaze3.png',
      'gallery/gaze4.png',
      'gallery/gaze5.png',
      'gallery/A_cinematic_sequence_202509150738_5atxf.mp4',
      'gallery/Generate_a_video_202509150738_mole9.mp4'
    ];
    
    // Verificar que los archivos existen manteniendo el orden original
    const validMedia = [];
    let checked = 0;
    
    const checkMediaFile = (src, originalIndex) => {
      if (isImageFile(src)) {
        // Para imágenes, usar el método anterior
        const img = new Image();
        img.onload = () => {
          validMedia.push({ src, type: 'image', originalIndex });
          checked++;
          if (checked === mediaList.length) {
            // Ordenar por índice original para mantener el orden del mediaList
            setMedia(validMedia.sort((a, b) => a.originalIndex - b.originalIndex));
            setIsLoading(false);
          }
        };
        img.onerror = () => {
          console.warn('No se pudo cargar la imagen:', src);
          checked++;
          if (checked === mediaList.length) {
            setMedia(validMedia.sort((a, b) => a.originalIndex - b.originalIndex));
            setIsLoading(false);
          }
        };
        img.src = src;
      } else if (isVideoFile(src)) {
        // Para videos, intentar cargar metadata
        const video = document.createElement('video');
        video.onloadedmetadata = () => {
          validMedia.push({ src, type: 'video', originalIndex });
          checked++;
          if (checked === mediaList.length) {
            setMedia(validMedia.sort((a, b) => a.originalIndex - b.originalIndex));
            setIsLoading(false);
          }
        };
        video.onerror = () => {
          console.warn('No se pudo cargar el video:', src);
          checked++;
          if (checked === mediaList.length) {
            setMedia(validMedia.sort((a, b) => a.originalIndex - b.originalIndex));
            setIsLoading(false);
          }
        };
        video.src = src;
      } else {
        // Archivo no reconocido
        console.warn('Tipo de archivo no soportado:', src);
        checked++;
        if (checked === mediaList.length) {
          setMedia(validMedia.sort((a, b) => a.originalIndex - b.originalIndex));
          setIsLoading(false);
        }
      }
    };

    mediaList.forEach((src, index) => checkMediaFile(src, index));
    
    // Si no hay archivos, terminar la carga
    if (mediaList.length === 0) {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    const handleKeyPress = (e) => {
      // ESC para volver al viewer 3D
      if (e.key === 'Escape') {
        const backButton = document.querySelector('[onclick*="spider2"]');
        if (backButton) {
          backButton.click();
        } else {
          // Buscar botón de otra manera
          const buttons = document.querySelectorAll('button');
          buttons.forEach(btn => {
            if (btn.textContent.includes('Volver')) {
              btn.click();
            }
          });
        }
        return;
      }
      
      if (media.length === 0) return;
      
      if (e.key === 'ArrowLeft') {
        handlePrevious();
      } else if (e.key === 'ArrowRight') {
        handleNext();
      } else if (e.key === ' ') {
        e.preventDefault();
        // Si es un video, pausar/reproducir, si no, toggle thumbnails
        const currentMedia = media[currentIndex];
        if (currentMedia && currentMedia.type === 'video') {
          const video = document.querySelector('video');
          if (video) {
            if (video.paused) {
              video.play();
            } else {
              video.pause();
            }
          }
        } else {
          setShowThumbnails(!showThumbnails);
        }
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [currentIndex, media.length, showThumbnails]);

  const handleNext = () => {
    if (media.length > 0) {
      setCurrentIndex((prev) => (prev + 1) % media.length);
    }
  };

  const handlePrevious = () => {
    if (media.length > 0) {
      setCurrentIndex((prev) => (prev - 1 + media.length) % media.length);
    }
  };

  const getFileName = (path) => {
    return path.split('/').pop();
  };

  const styles = {
    container: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100vw',
      height: '100vh',
      background: '#000000',
      display: 'flex',
      flexDirection: 'column',
      padding: '40px',
      zIndex: 9999,
      overflow: 'hidden',
    },
    header: {
      textAlign: 'center',
      marginBottom: '30px',
      paddingBottom: '20px',
      borderBottom: '1px solid rgba(200, 180, 150, 0.15)',
    },
    title: {
      fontSize: '36px',
      fontWeight: 100,
      letterSpacing: '0.5em',
      color: 'rgba(200, 180, 150, 0.9)',
      marginBottom: '10px',
      textTransform: 'uppercase',
    },
    subtitle: {
      fontSize: '14px',
      color: 'rgba(200, 180, 150, 0.5)',
      letterSpacing: '0.2em',
    },
    mainContent: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
    },
    mediaContainer: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
    },
    media: {
      maxWidth: '90%',
      maxHeight: '70vh',
      objectFit: 'contain',
      borderRadius: '8px',
      boxShadow: '0 10px 40px rgba(0, 0, 0, 0.8)',
    },
    navigationButton: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      padding: '20px',
      background: 'rgba(10, 10, 10, 0.8)',
      border: '1px solid rgba(200, 180, 150, 0.2)',
      borderRadius: '50%',
      color: 'rgba(200, 180, 150, 0.7)',
      fontSize: '24px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      fontFamily: 'inherit',
      backdropFilter: 'blur(10px)',
      width: '60px',
      height: '60px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10,
    },
    navigationButtonHover: {
      background: 'rgba(200, 180, 150, 0.15)',
      border: '1px solid rgba(200, 180, 150, 0.4)',
      color: 'rgba(200, 180, 150, 0.9)',
      transform: 'translateY(-50%) scale(1.1)',
    },
    prevButton: {
      left: '40px',
    },
    nextButton: {
      right: '40px',
    },
    counter: {
      position: 'absolute',
      bottom: '30px',
      left: '50%',
      transform: 'translateX(-50%)',
      padding: '10px 20px',
      background: 'rgba(10, 10, 10, 0.9)',
      borderRadius: '20px',
      border: '1px solid rgba(200, 180, 150, 0.2)',
      color: 'rgba(200, 180, 150, 0.8)',
      fontSize: '14px',
      letterSpacing: '0.1em',
      backdropFilter: 'blur(10px)',
    },
    thumbnailsContainer: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      padding: '20px',
      background: 'linear-gradient(to top, rgba(0, 0, 0, 0.95) 0%, transparent 100%)',
      backdropFilter: 'blur(10px)',
      transition: 'transform 0.3s ease',
      transform: showThumbnails ? 'translateY(0)' : 'translateY(100%)',
      zIndex: 10000,
    },
    thumbnailsScroll: {
      display: 'flex',
      gap: '10px',
      overflowX: 'auto',
      padding: '10px 0',
      justifyContent: 'center',
      alignItems: 'center',
      maxWidth: '100%',
    },
    thumbnail: {
      minWidth: '80px',
      width: '80px',
      height: '60px',
      borderRadius: '4px',
      cursor: 'pointer',
      opacity: 0.5,
      transition: 'all 0.2s ease',
      border: '2px solid transparent',
      objectFit: 'cover',
      position: 'relative',
    },
    thumbnailActive: {
      opacity: 1,
      border: '2px solid rgba(200, 180, 150, 0.6)',
      transform: 'scale(1.1)',
    },
    videoOverlay: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '20px',
      height: '20px',
      background: 'rgba(200, 180, 150, 0.8)',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '10px',
      color: '#000',
      pointerEvents: 'none',
    },
    errorMessage: {
      textAlign: 'center',
      color: 'rgba(200, 180, 150, 0.5)',
      fontSize: '14px',
      padding: '40px',
      background: 'rgba(0, 0, 0, 0.5)',
      borderRadius: '8px',
    },
    backButton: {
      position: 'fixed',
      top: '20px',
      right: '20px',
      padding: '10px 20px',
      background: 'rgba(200, 180, 150, 0.1)',
      border: '1px solid rgba(200, 180, 150, 0.3)',
      borderRadius: '6px',
      color: 'rgba(200, 180, 150, 0.9)',
      fontSize: '12px',
      fontWeight: 600,
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      fontFamily: 'inherit',
      zIndex: 10001,
      backdropFilter: 'blur(10px)',
    },
    toggleButton: {
      position: 'fixed',
      bottom: showThumbnails ? '140px' : '20px',
      right: '20px',
      padding: '10px',
      background: 'rgba(10, 10, 10, 0.9)',
      border: '1px solid rgba(200, 180, 150, 0.3)',
      borderRadius: '6px',
      color: 'rgba(200, 180, 150, 0.7)',
      fontSize: '11px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      fontFamily: 'inherit',
      backdropFilter: 'blur(10px)',
      zIndex: 10001,
    },
    instructions: {
      position: 'fixed',
      top: '20px',
      left: '20px',
      padding: '15px',
      background: 'rgba(10, 10, 10, 0.9)',
      borderRadius: '8px',
      border: '1px solid rgba(200, 180, 150, 0.2)',
      color: 'rgba(200, 180, 150, 0.6)',
      fontSize: '11px',
      lineHeight: 1.6,
      backdropFilter: 'blur(10px)',
      maxWidth: '200px',
      zIndex: 10001,
    },
  };

  const [hoveredButton, setHoveredButton] = useState(null);

  if (isLoading) {
    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <h1 style={styles.title}>Galería</h1>
          <div style={styles.subtitle}>Cargando archivos multimedia...</div>
        </div>
      </div>
    );
  }

  if (media.length === 0) {
    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <h1 style={styles.title}>Galería</h1>
          <div style={styles.subtitle}>Sin contenido disponible</div>
        </div>
        <div style={styles.errorMessage}>
          No hay imágenes o videos configurados.
          <br /><br />
          Edita el archivo Gallery.jsx y añade tus archivos multimedia en la línea 17.
          <br />
          Formatos soportados: JPG, PNG, GIF, WebP, MP4, WebM, OGG, MOV
        </div>
        
        <button
          style={styles.backButton}
          onClick={() => {
            const viewerButtons = document.querySelectorAll('button');
            viewerButtons.forEach(btn => {
              if (btn.textContent.includes('Araña') || btn.textContent.includes('spider2')) {
                btn.click();
              }
            });
          }}
        >
          ← VOLVER AL VIEWER 3D
        </button>
      </div>
    );
  }

  const currentMedia = media[currentIndex];

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Galería</h1>
      </div>

      {/* Instrucciones */}
      <div style={styles.instructions}>
        ← → Navegar<br />
        ESPACIO {currentMedia?.type === 'video' ? 'Play/Pausa' : 'Miniaturas'}<br />
        ESC Salir
      </div>

      <div style={styles.mainContent}>
        <div style={styles.mediaContainer}>
          {/* Botón Anterior */}
          <button
            style={{
              ...styles.navigationButton,
              ...styles.prevButton,
              ...(hoveredButton === 'prev' ? styles.navigationButtonHover : {})
            }}
            onClick={handlePrevious}
            onMouseEnter={() => setHoveredButton('prev')}
            onMouseLeave={() => setHoveredButton(null)}
            disabled={media.length <= 1}
          >
            ‹
          </button>

          {/* Contenido principal */}
          {currentMedia && (
            currentMedia.type === 'video' ? (
              <video
                key={currentMedia.src}
                src={currentMedia.src}
                style={styles.media}
                controls
                autoPlay={false}
                loop
                muted
              />
            ) : (
              <img
                key={currentMedia.src}
                src={currentMedia.src}
                alt={`Imagen ${currentIndex + 1}`}
                style={styles.media}
              />
            )
          )}

          {/* Botón Siguiente */}
          <button
            style={{
              ...styles.navigationButton,
              ...styles.nextButton,
              ...(hoveredButton === 'next' ? styles.navigationButtonHover : {})
            }}
            onClick={handleNext}
            onMouseEnter={() => setHoveredButton('next')}
            onMouseLeave={() => setHoveredButton(null)}
            disabled={media.length <= 1}
          >
            ›
          </button>

          {/* Contador */}
          {media.length > 0 && (
            <div style={styles.counter}>
              <div>{currentIndex + 1} / {media.length}</div>
              <div style={{ fontSize: '11px', color: 'rgba(200, 180, 150, 0.5)', marginTop: '4px' }}>
                {getFileName(currentMedia.src)} 
                <span style={{ color: 'rgba(200, 180, 150, 0.3)', marginLeft: '8px' }}>
                  [{currentMedia.type === 'video' ? '📹' : '🖼️'}]
                </span>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* BOTÓN PARA VOLVER AL VIEWER 3D */}
      <button
        style={{
          ...styles.backButton,
          ...(hoveredButton === 'back' ? {
            background: 'rgba(200, 180, 150, 0.2)',
            border: '1px solid rgba(200, 180, 150, 0.5)',
            transform: 'scale(1.05)',
          } : {})
        }}
        onMouseEnter={() => setHoveredButton('back')}
        onMouseLeave={() => setHoveredButton(null)}
        onClick={() => {
          const buttons = document.querySelectorAll('button');
          let found = false;
          buttons.forEach(btn => {
            if (btn.textContent.includes('Araña 2') || 
                btn.textContent.includes('spider2') ||
                btn.textContent.includes('Pintura')) {
              btn.click();
              found = true;
            }
          });
          if (!found) {
            window.location.reload();
          }
        }}
      >
        ← VOLVER AL VIEWER 3D
      </button>

      {/* Botón toggle miniaturas */}
      <button
        style={{
          ...styles.toggleButton,
          ...(hoveredButton === 'toggle' ? {
            background: 'rgba(200, 180, 150, 0.15)',
            border: '1px solid rgba(200, 180, 150, 0.5)',
            color: 'rgba(200, 180, 150, 0.9)',
          } : {})
        }}
        onClick={() => setShowThumbnails(!showThumbnails)}
        onMouseEnter={() => setHoveredButton('toggle')}
        onMouseLeave={() => setHoveredButton(null)}
      >
        {showThumbnails ? 'Ocultar' : 'Mostrar'} miniaturas
      </button>

      {/* Miniaturas */}
      {media.length > 1 && showThumbnails && (
        <div style={styles.thumbnailsContainer}>
          <div style={styles.thumbnailsScroll}>
            {media.map((item, index) => (
              <div 
                key={item.src}
                style={{ position: 'relative' }}
                onClick={() => setCurrentIndex(index)}
              >
                {item.type === 'video' ? (
                  <>
                    <video
                      src={item.src}
                      style={{
                        ...styles.thumbnail,
                        ...(index === currentIndex ? styles.thumbnailActive : {})
                      }}
                      muted
                    />
                    <div style={styles.videoOverlay}>▶</div>
                  </>
                ) : (
                  <img
                    src={item.src}
                    alt={`Miniatura ${index + 1}`}
                    title={getFileName(item.src)}
                    style={{
                      ...styles.thumbnail,
                      ...(index === currentIndex ? styles.thumbnailActive : {})
                    }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;

